// extracted by mini-css-extract-plugin
export default {"button":"button-view-glossary_button__z99jI"};